<template>
  <div id="user-log" class="user-actions">
    <div class="panelheader">
      <div class="title">User Actions</div>
    </div>
    <div class="body">

    <div class="log_actions">
      <template>
        <vuetable
          ref="vuetable"
          api-url="/api/logs/bookings"
          :http-options="header"
          :fields="columns"
          :per-page="10"
          :append-params="moreParams"
          pagination-path=""
          @vuetable:pagination-data="onPaginationData"
        >
          </vuetable>
          <div class="vuetable-pagination ui basic segment grid">
            <vuetable-pagination-info ref="paginationInfo"></vuetable-pagination-info>
              <vuetable-pagination
                  ref="pagination"
                  @vuetable-pagination:change-page="onChangePage">
              </vuetable-pagination>
          </div>
      </template>
    </div>
    </div>
  </div>
</template>

<script>
  import auth from '../../auth';
  import dateFormat from 'dateformat'

  export default {
    props: {
      displayFields: Array,
      dateRange: Object
    },
    'name':'user-actions',
    data(){
        return {
          filteredData: {},
          header: {},
          filterText:'Field C',
          columns: [
            {name: 'id', title: 'ID', titleClass: 'hidden', dataClass: 'hidden'},
            {name: 'username', title: 'User', sortField: 'users.username'},
            {name: 'field_name', title: 'Field', sortField: 'fields.field_name'},
            {name: 'site_name', title: 'Site', sortField: 'sites.name'},
            {name: 'action_time', title: 'Action Time', sortField: 'log_bookings.action_time'},
            {name: 'log_type', title: 'Action', sortField:'log_bookings.log_type'},
            {name: 'scene_name', title: 'Scene', dataClass: 'center aligned', sortField:'log_bookings.scene_name'},
            {name: 'booking_id', title: 'Booking ID', sortField: 'bookings.id'},
            {name: 'start_time', title: 'Booking Times', sortField: 'bookings.start_time', callback: 'formatBookingTime'}
          ],
          paginationData: [],
          moreParams: {}
        }
    },
    beforeMount() {
      var header = {headers: auth.getAuthHeader()};
      this.header = {headers:{'x-access-token':header['headers']['x-access-token']}};
      this.moreParams = {
        fields: this.displayFields,
        to: new Date(this.dateRange.to),
        from: new Date(this.dateRange.from)
      }
      this.$nextTick(() => { this.$refs.vuetable.refresh() })
    },
    methods: {
      onPaginationData(paginationData) {
        this.paginationData = paginationData
        this.$refs.pagination.setPaginationData(this.paginationData);
        this.$refs.paginationInfo.setPaginationData(this.paginationData);
      },
      onChangePage (page) {
        this.$refs.vuetable.changePage(page)
      },
      formatBookingTime (start_time) {
        if (start_time) {
          try {
            if (this.paginationData && this.paginationData.data) {
              const dataRow = this.paginationData.data.find(v => v.start_time == start_time)
              if (!dataRow) { return null }

              const end_time = dataRow.end_time
              const formatted_start = dateFormat(new Date(start_time), 'dd/mm/yy @ HH:MM')

              let formatted_end = ''
              if (end_time) {
                formatted_end = dateFormat(new Date(end_time), '- HH:MM')
              }
              return `${formatted_start} ${formatted_end}`
            }
          } catch (error) {
            console.error('Error in formatBookingTime:', error)
            return null
          }
          return null
        }
        return null
      }
    },
    watch: {
      displayFields (newFields) {
        this.moreParams.fields = newFields
        this.$nextTick(() => { this.$refs.vuetable.refresh() })
      },
      dateRange: {
        handler (newDateRange) {
          this.moreParams.to = newDateRange.to
          this.moreParams.from = newDateRange.from
          this.$nextTick(() => { this.$refs.vuetable.refresh() })
        },
        deep: true
      }
    }
  }
</script>

<style>
  .log_actions {
    display: block;
    padding: 15pt;
    background-color: white;
  }

  .log_actions .ui.menu {
    font-size: 0.8rem;
  }

  .log_actions .ui.basic.segment {
    background-color: #F2F2F2;
  }
</style>


// WEBPACK FOOTER //
// UserActions.vue?744d1916